<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      fixed
      clipped
      right
      temporary
      class="dynamic-nav-drawer-container"
    >
      <div class="close-bar">
        <div @click="drawerClosed">
          <v-icon large>{{ icons.mdiClose }}</v-icon>
        </div>
      </div>
      <section class="drawer-content-container">
        <div v-if="title" class="header">
          <span class="title">
            {{ title }}
          </span>
          <span class="description">{{ description }}</span>
        </div>
        <div>
          <slot name="content"></slot>
        </div>
      </section>
    </v-navigation-drawer>
  </div>
</template>

<script>
  import { mdiClose } from '@mdi/js';
  import { mapGetters } from 'vuex';
  export default {
    name: 'DynamicNavDrawer',
    props: {
      drawerOpen: {
        required: true,
        default: false,
        type: Boolean,
      },
      title: {
        required: false,
        default: null,
        type: String,
      },
      description: {
        required: false,
        default: null,
        type: String,
      },
      type: {
        required: false,
        default: null,
        type: String,
      },
    },
    data(props) {
      return {
        drawer: props.drawerOpen,
        icons: {
          mdiClose: mdiClose,
        },
      };
    },
    computed: {
      ...mapGetters(['coBrandCompanyUrl']),
      ...mapGetters(['coBrandCompanyName']),
    },
    watch: {
      drawerOpen(newVal) {
        this.drawer = newVal;
        if (newVal) {
          if (this.type === 'signup') {
            dataLayer.push({
              event: 'signupslide',
              omuserid: 'systemuserid',
            });
          } else if (this.type === 'signin') {
            dataLayer.push({
              event: 'loginslide',
              omuserid: 'systemuserid',
            });
          }
        }
      },
      drawer(newVal) {
        if (!newVal) {
          this.drawerClosed();
        }
      },
    },
    methods: {
      drawerClosed() {
        this.$emit('drawerClosed');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .dynamic-nav-drawer-container {
    max-height: 100dvh;
    z-index: 1001;
    width: clamp(326px, 75dvw, 462px) !important;

    .close-bar {
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      padding: 16px 16px 0 16px;
      div {
        cursor: pointer;

        .v-icon {
          color: #282828 !important;
        }
      }
    }
    .drawer-content-container {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 24px;

      div:first-child {
        width: clamp(0px, 95%, 402px) !important;
      }
    }

    .header {
      display: flex;
      flex-direction: column;
      margin-bottom: 24px;
      width: 100%;
      .title {
        font-family: 'Montserrat', sans-serif !important;
        font-size: 22px;
        font-weight: 600;
        line-height: 30px;
        color: #282828;
      }

      .description {
        font-family: 'Montserrat', sans-serif !important;
        font-size: 14px;
        font-weight: 400;
        line-height: 18.2px;
        color: #282828;
      }
    }
  }
  @media only screen and (min-width: 0px) and (max-width: 959px) {
    .dynamic-nav-drawer-container {
      .drawer-content-container {
        padding-top: 0;
      }
    }
  }
</style>
